import { render, staticRenderFns } from "./FooterBig.vue?vue&type=template&id=2afdb6ed&scoped=true&"
import script from "./FooterBig.vue?vue&type=script&lang=js&"
export * from "./FooterBig.vue?vue&type=script&lang=js&"
import style0 from "./FooterBig.vue?vue&type=style&index=0&id=2afdb6ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afdb6ed",
  null
  
)

export default component.exports